
    <app-loading-overlay *ngIf="loading$ | async; else layout" message="Loading your dashboard..."></app-loading-overlay>
	    <ng-template #layout>
	        <div class="flex min-h-screen bg-[color:var(--background)] text-[color:var(--foreground)] overflow-x-hidden">
	            <app-sidebar [navigation]="(navigation$ | async) || customerNavigation" [isMobileOpen]="mobileNavOpen" (mobileClose)="mobileNavOpen = false"></app-sidebar>
	            <div class="lg:pl-64 flex-1 min-w-0">
	                <app-dashboard-header [heading]="'Investor Dashboard'" [subheading]="'Track your reservations'" (toggleSidebar)="mobileNavOpen = !mobileNavOpen"></app-dashboard-header>
	                <main class="pt-10 pb-28 px-4 sm:py-10 sm:px-6 lg:px-8 mx-auto w-full min-w-0">
	                    <router-outlet></router-outlet>
	                </main>
                    <app-mobile-bottom-nav [navigation]="(navigation$ | async) || customerNavigation"></app-mobile-bottom-nav>
	            </div>
	        </div>
	    </ng-template>
	    
